import DoneIcon from '@mui/icons-material/Done';
import SnoozeOutlinedIcon from '@mui/icons-material/SnoozeOutlined';
import { Avatar, Grid, IconButton, Paper, Stack, Tooltip } from '@mui/material';
import { FC } from 'react';
import {
  TeamIcon,
  TaskIcon,
  CandidateIconAlt,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  SmtpSetupConfigIcon,
} from 'wisestep-base';

import NotificationDTO from '../types/NotificationDTO';
export interface NotificationLayoutProps {
  notificationTitle?: string;
  notificationSubtext?: string;
  notificationType?: string;
  onClickLink?: string;
  onCloseHandler?: () => void;
  onCompleteTask?: () => void;
  onSnoozeClick?: () => void;
  taskDetails?: NotificationDTO;
}
const NotificationLayout: FC<NotificationLayoutProps> = ({
  notificationTitle = '',
  notificationSubtext = '',
  notificationType = '',
  onCompleteTask,
  onSnoozeClick,
  onCloseHandler,
}) => {
  const dynamicIcon = (notificationType: string) => {
    let icon = <TaskIcon width={50} height={50} />;
    const iconHandle = {
      ['OVERDUE_TASK']: () => {
        icon = <TaskIcon width={50} height={50} />;
      },
      ['CANDIDATE_SUBMISSION']: () => {
        icon = <CandidateIconAlt />;
      },
      ['STAGE_STATUS_CHANGED']: () => {
        icon = <CandidateIconAlt />;
      },
      ['NOTE_ADDED']: () => {
        icon = <CandidateIconAlt />;
      },
      ['CLOSE_JOB']: () => {
        icon = <TeamIcon width={50} height={50} />;
      },
      ['CANDIDATE_APPLICATION']: () => {
        icon = <CandidateIconAlt />;
      },
      ['JOB_ASSIGNMENT']: () => {
        icon = <TeamIcon width={50} height={50} />;
      },
      ['HARVESTING']: () => {
        icon = <TeamIcon width={50} height={50} />;
      },
      ['INBOUND_SMS']: () => {
        icon = <TeamIcon width={50} height={50} />;
      },
      ['NEW_EMAIL']: () => {
        icon = <SmtpSetupConfigIcon />;
      },
      ['EMAIL_DATA']: () => {
        icon = <></>;
      },
    };
    iconHandle[notificationType]();
    return icon;
  };

  return (
    <Paper
      elevation={1}
      onClick={() => {
        // window.open(onClickLink, '_blank');
        // onCloseHandler && onCloseHandler();
      }}
    >
      <Grid item xs={13} container justifyContent="flex-end" width={300} height={10}>
        <Stack direction="row">
          <Tooltip title="Edit" placement="top">
            <IconButton onClick={() => onSnoozeClick && onSnoozeClick()}>
              <SnoozeOutlinedIcon sx={{ width: 24, height: 24 }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Complete" placement="top">
            <IconButton
              onClick={() => {
                onCompleteTask && onCompleteTask();
                onCloseHandler && onCloseHandler();
              }}
            >
              <DoneIcon sx={{ width: 24, height: 24 }} />
            </IconButton>
          </Tooltip>
        </Stack>
      </Grid>
      <Grid container mt={1} pt={2} width={300} height={100}>
        <Grid item direction="column" xs={2} pl={1}>
          <Avatar>{dynamicIcon(notificationType)}</Avatar>
        </Grid>
        <Grid item xs={10}>
          <Grid container direction="column">
            <Grid marginLeft={2} item xs={9}>
              <WsTypography variant={WsTypoVariants.BODY1}>{notificationTitle}</WsTypography>
            </Grid>
            <Grid item mt={1} xs={3} alignSelf="baseline">
              <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.TERTIARY}>
                {notificationSubtext}
              </WsTypography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};
export default NotificationLayout;
